import { render, staticRenderFns } from "./splitRoom.vue?vue&type=template&id=212e246a&scoped=true"
import script from "./splitRoom.vue?vue&type=script&lang=js"
export * from "./splitRoom.vue?vue&type=script&lang=js"
import style0 from "./splitRoom.vue?vue&type=style&index=0&id=212e246a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e246a",
  null
  
)

export default component.exports